import {Navbar} from '~/components/molecules'

import './index.scss'

const NavbarHeader = (): JSX.Element => {
  return (
    <header>
      <Navbar />
    </header>
  )
}

export default NavbarHeader
